'use strict';

Object.defineProperties(exports, { __esModule: { value: true }, [Symbol.toStringTag]: { value: 'Module' } });

const clsx = require('clsx');
const React = require('react');
const SecondaryNav_SecondaryNavContext = require('./SecondaryNavContext.cjs.js');
const SecondaryNav_SecondaryNavItem = require('./SecondaryNavItem.cjs.js');
const SecondaryNav_SecondaryNavList = require('./SecondaryNavList.cjs.js');
const SecondaryNav_SecondaryNavTitle = require('./SecondaryNavTitle.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const secondaryNav = "_secondary-nav_clfmr_1";
const styles = {
	secondaryNav: secondaryNav
};

const SecondaryNavRoot = ({ children, className, defaultSelectedItem = null, defaultExpandedKeys = [], selectedItem, onSelectedItemChange, expandedKeys, onExpandedKeysChange }) => {
  const [localSelectedItem, setLocalSelectedItem] = React.useState(defaultSelectedItem);
  const [localExpandedKeys, setLocalExpandedKeys] = React.useState(defaultExpandedKeys);
  const isSelectedItemControlled = !!selectedItem;
  const isExpandedKeysControlled = !!expandedKeys;
  const currentSelectedItem = selectedItem !== null && selectedItem !== void 0 ? selectedItem : localSelectedItem;
  const currentExpandedKeys = expandedKeys !== null && expandedKeys !== void 0 ? expandedKeys : localExpandedKeys;
  const state = React.useMemo(() => ({
    selectedItemKey: currentSelectedItem,
    expandedSectionKeys: currentExpandedKeys,
    registerSelectedItemKey: (key) => {
      onSelectedItemChange === null || onSelectedItemChange === void 0 ? void 0 : onSelectedItemChange(key);
      if (!isSelectedItemControlled) {
        setLocalSelectedItem(key);
      }
    },
    registerExpandedSectionKeys: (keys) => {
      onExpandedKeysChange === null || onExpandedKeysChange === void 0 ? void 0 : onExpandedKeysChange(keys);
      if (!isExpandedKeysControlled) {
        setLocalExpandedKeys(keys);
      }
    }
  }), [
    currentSelectedItem,
    currentExpandedKeys,
    isSelectedItemControlled,
    isExpandedKeysControlled,
    onSelectedItemChange,
    onExpandedKeysChange
  ]);
  return React__default.default.createElement(
    SecondaryNav_SecondaryNavContext.SecondaryNavContext.Provider,
    { value: state },
    React__default.default.createElement("nav", { className: clsx.clsx(styles.secondaryNav, className), "data-zds": true }, children)
  );
};
const SecondaryNav = Object.assign(SecondaryNavRoot, {
  Title: SecondaryNav_SecondaryNavTitle.SecondaryNavTitle,
  Item: SecondaryNav_SecondaryNavItem.SecondaryNavItem,
  List: SecondaryNav_SecondaryNavList.SecondaryNavList
});

exports.SecondaryNav = SecondaryNav;
exports.SecondaryNavRoot = SecondaryNavRoot;
exports.default = SecondaryNav;
//# sourceMappingURL=SecondaryNav.cjs.js.map
